function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9593 7.33317C13.6527 4.55317 11.446 2.3465 8.66602 2.03984V0.666504H7.33268V2.03984C4.55268 2.3465 2.34602 4.55317 2.03935 7.33317H0.666016V8.6665H2.03935C2.34602 11.4465 4.55268 13.6532 7.33268 13.9598V15.3332H8.66602V13.9598C11.446 13.6532 13.6527 11.4465 13.9593 8.6665H15.3327V7.33317H13.9593ZM7.99935 5.33317C6.52602 5.33317 5.33268 6.5265 5.33268 7.99984C5.33268 9.47317 6.52602 10.6665 7.99935 10.6665C9.47268 10.6665 10.666 9.47317 10.666 7.99984C10.666 6.5265 9.47268 5.33317 7.99935 5.33317ZM3.33268 7.99984C3.33268 10.5798 5.41935 12.6665 7.99935 12.6665C10.5793 12.6665 12.666 10.5798 12.666 7.99984C12.666 5.41984 10.5793 3.33317 7.99935 3.33317C5.41935 3.33317 3.33268 5.41984 3.33268 7.99984Z",
  fill: "#111111"
}));

var SvgMyLocation = function SvgMyLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my_location.e497d300.svg";
export { ForwardRef as ReactComponent };